export const lifestyles = ['inactive', 'sedentary', 'active', 'vigorous', 'extremely_active']
